// The one merged grant map this portal evaluates — extracted from main.tsx so
// SessionProvider (affordance gates) and nav.ts (the sidebar) read the SAME
// matrix; two copies could drift into a sidebar offering what the gates hide.
// Key-wise union, never a spread. useCan is UI sugar; the API is the authority.
import { mergeGrants, ROLE_GRANTS } from "@erp/auth-kit/rbac";
import { FIN_GRANTS } from "@erp/module-fin/schemas";
import { GUARD_GRANTS } from "@erp/module-guard/schemas";
import { LIB_GRANTS } from "@erp/module-lib/schemas";

// FIN_GRANTS rides along for role completeness (an owner/admin visiting the
// staff desk evaluates fin:verify here exactly as the gateway does); the
// payments desk itself admits lib:desk/lib:admin via the module-scoped
// verifier rule, no fin:* required.
export const GRANTS = mergeGrants(ROLE_GRANTS, LIB_GRANTS, FIN_GRANTS, GUARD_GRANTS);
